<template>
	<section class="promotions">
		<div class="row">
			<div
				v-for="(block, index) in items.slice(0, amount)"
				:key="block.ID"
				data-aos="fade-in"
				data-aos-duration="1500"
				data-aos-once="true"
				:data-aos-delay="index + '00'"
				class="promoblock"
			>
				<div class="content">
					<h2>{{ block.header }}</h2>
					<div v-parse-links v-html="block.content" />
				</div>
				<picture>
					<source v-if="block.imageWebp" :srcset="block.image" type="image/webp" />
					<source :srcset="block.image" />
					<img :src="block.image" :alt="block.imageAlt" class="promo-img" loading="lazy" />
				</picture>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	items: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
});
</script>

<style lang="scss" scoped>
.row {
	justify-content: center;
}

.promotions {
	display: flex;
	flex-flow: row wrap;
	width: 100%;
	background: var(--secondary-background-color);
	padding-top: 40px;

	.promoblock {
		max-width: 1280px;
		flex-basis: calc(100% / 3 - 30px);
		text-decoration: none;
		border-radius: 6px;
		margin: 0 15px;
		position: relative;

		.content {
			position: absolute;
			top: 50%;
			left: 10px;
			right: 10px;
			margin-top: -55px;
			text-align: center;
			color: #fff;
			z-index: 2;

			h2,
			h3,
			h2 a,
			h3 a {
				color: #fff;
				margin: 0 0 30px;
			}

			h2 {
				font-family: var(--heading-font-family);
				font-weight: 700;
			}
		}

		.promo-img {
			opacity: 1;
			width: 100%;
			transition: all 0.3s ease-in-out;
		}

		&:hover .promo-img {
			opacity: 1;
		}

		&::after {
			content: '';
			position: absolute;
			inset: 0;
			background: rgb(0 0 0 / 20%);
			transition: all 0.3s ease-in-out;
		}

		&:hover::after {
			background: rgb(0 0 0 / 0%);
		}
	}
}

@media (max-width: 800px) {
	.promotions .promoblock {
		flex-basis: calc(100% - 20px);
		margin-bottom: 40px;
	}
}
</style>
